import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOChangeApi } from '@/api/pto'
import { getUserFullName } from '@/utils/user'
import { mapJobItem } from '@/utils/page/pto/project/pto/map'
import { vuexFileBase } from '@/store/compositionV2/utils/file'
import { vuexSaveItemAndFiles } from '@/store/compositionV2/saveItemAndFiles'
import { EAppTableMod } from '@/components/page/table/types'
import router from '@/router'

function getRouteEstimateUpdate (item) {
  return {
    name: 'PtoProjectEstimateUpdate',
    params: {
      id: item.id,
      projectId: router.currentRoute.params.projectId
    }
  }
}

const state = () => ({
  ...vuexPto.createState(),
  ...vuexFileBase.createState(),

  api: PTOChangeApi,
  namePageDetailed: 'PtoProjectChangeUpdate',
  expand: 'created_by,jobs,files,estimates',
  tableHeaders: [
    {
      title: '№ изменения',
      isSortable: true,
      sortName: 'number'
    },
    {
      title: 'Дата получения изменения',
      isSortable: true,
      sortName: 'receive_date'
    },
    {
      title: '№ сметы',
      isSortable: true,
      sortName: 'estimate_number'
    },
    {
      title: 'Кто создал',
      isSortable: true,
      sortName: 'updated_by.surname'
    },
    {
      title: 'Примечание',
      isSortable: true,
      sortName: 'note'
    },
    {
      title: 'Загружено файлов',
      isSortable: false
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  ...vuexFileBase.createGetters(),
  getList: state => {
    return state.list.map(item => {
      let filesCount = {
        count: '0 файлов'
      }
      if (item.files) {
        filesCount = {
          count: item.files.length + ' файлов'
        }
      }

      const estimates = {
        mod: EAppTableMod.links,
        data: item.estimates?.map(item => ({
          id: item.id,
          text: item.estimate
        })) || [],
        getRouteHandler: getRouteEstimateUpdate
      }

      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.number || '-',
          item.receive_date || '-',
          estimates,
          getUserFullName(item.created_by) || '-',
          { data: item.note || '-', mod: 'comments' },
          { data: filesCount, mod: 'countFiles' }
        ]
      }
    })
  },
  getCurrentItem: state => ({
    ...state.currentItem,
    jobs: state.currentItem.jobs?.length ? state.currentItem.jobs.map(mapJobItem) : []
  })
}

const mutations = {
  ...vuexPto.createMutations(),
  ...vuexFileBase.createMutations()
}

const actions = {
  ...vuexPto.createActions(),
  ...vuexSaveItemAndFiles.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
